import { GridModel, GridPostParams } from "common/models/utility-models/list-utility.model";
import { FeedbackMappingModel } from "./feedback-mapping-data-model";

export class FeedbackMappingGridModel extends FeedbackMappingModel { }

export class FeedbackMappingListingModel extends GridModel<FeedbackMappingGridModel> { }

export class FeedbackMappingGridParams extends GridPostParams {
    pageNumber: 1;
    pageSize: 10;
    searchText: '';
    direction: '';
    column: ''
}